// extracted by mini-css-extract-plugin
export default {"cover_section":"home-cover_cover_section__iYS3W","logoCover":"home-cover_logoCover__RIgd-","logo":"home-cover_logo__5isaU","coverImg":"home-cover_coverImg__ekY1u"};